<template>
  <b-row class="mt-3">
    <b-col class="text-left">
      <b-form-group label="CUSIP Search" class="font-weight-bold float-right w-180">
        <b-input-group>
          <b-form-input type="text" v-model="cusip" required placeholder="CUSIP" size="sm"></b-form-input>
          <b-input-group-append>
            <b-button variant="info" @click="searchByCusip" size="sm">Search</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <p v-if="dealName !== ''" class="float-right w-180">
        <router-link :to="{path:'/bond_analysis', query: {dealName : dealName, bondName: bondName}}">Deal: {{dealName}} <br> Bond: {{bondName}}</router-link>
      </p>
      <alert ref="alert" full="true" />
    </b-col>
  </b-row>
</template>

<script>
import service from '../../services/HttpRequestService';
import Alert from '../Alert';
import { TRACE_ERROR } from '../../constants';

export default {
  data() {
    return {
      cusip: '',
      dealName: '',
      bondName: '',
      error: ''
    };
  },
  methods: {
    async searchByCusip() {
      this.error = '';
      this.dealName = '';
      this.bondName = '';
      try {
        if (this.cusip == '') {
          this.$refs.alert.showAlert('danger', 'Please provide CUSIP');
          return;
        }
        this.$emit('showSpinner');
        let res = await service.getDealAndBondIdByCusip(this.cusip);
        this.dealName = res.data.DealName;
        this.bondName = res.data.BondName;
      } catch (err) {
        await service.log(TRACE_ERROR, err.response.data.Message, err.stack);
        this.$refs.alert.showAlert('danger', err.response.data.Message);
      }
      this.$emit('hideSpinner');
    }
  },
  components: {
    Alert
  }
};
</script>

<style lang="scss" scoped>
.w-180 {
  width: 180px;
}
</style>
